import { ReactNode } from "react"
import { Link } from "react-router-dom"

interface ButtonI {
	primary?: Boolean,
	secondary?: Boolean,
	text?: string,
	onClick?: () => void,
	children?: ReactNode,
	className?: string,
	isLink?: boolean,
	to?: string,
}

const Button = ({ primary, secondary, text, onClick, children, className = "", isLink, to = "" }: ButtonI) => {
	return (
		isLink ? <Link to={to} onClick={onClick} className={`${className} ${primary ? 'bg-primary text-white' : secondary ? 'bg-secondary text-white' : 'bg-white'} focused px-4 py-2 font-semibold rounded text-sm flex justify-center items-center space-x-2`}>
			{text} {children}
		</Link> :
			<button onClick={onClick} className={`${className} ${primary ? 'bg-primary text-white' : secondary ? 'bg-secondary text-white' : 'bg-white'} focused px-4 py-2 font-semibold rounded text-sm flex justify-center items-center space-x-2`}>
				{text} {children}
			</button>
	)
}

export default Button